import * as types from 'modules/dealers/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {string} State */
/** @type {string} */
const initialState = 'name,asc';

const updateState = (_, { payload }) => payload.request.params.sort;

export default createReducer(initialState, {
  [types.GET_MODAL_DEALERS]: updateState,
});
